import { toast } from "sonner";
import { env } from "@/env";

/**
 * Start a task in the background and return the run_id.
 *
 * Uses POST /tasks/{id}/start which kicks off execution server-side and
 * returns immediately with { run_id }. The caller then navigates to the
 * run viewer which joins the live stream via GET /runs/{id}/stream.
 */
export async function executeTaskNow(taskId: number, accessToken: string): Promise<string | null> {
	try {
		const response = await fetch(`${env.VITE_API_BASE_URL}/api/v1/tasks/${taskId}/start`, {
			method: "POST",
			headers: { Authorization: `Bearer ${accessToken}` },
		});
		if (!response.ok) {
			toast.error("Failed to start task");
			return null;
		}
		const data = await response.json();
		return String(data.run_id);
	} catch {
		toast.error("Failed to start task");
	}
	return null;
}
